import React, { useState } from "react";
import { useStore } from "../store";
import SubmitBtn from "./SubmitBtn";
import { size } from "../utlis/device";
import { device }  from "../utlis/device";
import axios from "axios";
import styled from "styled-components"; 

const FormStyle = styled.div `
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 50px 0px;
    @media ${device.tablet} {
      padding: 20px 0px;
  }
    
`
const FormWrapper = styled.form `
    background: #037a73;
    border-radius: 10px;
    padding: 40px;
    text-align: center;
    width: 80%;
    @media (max-width: ${size.tablet}) {
        flex-direction: column;
        width: 100%;
        padding: 20px;
        justify-content: center;
        align-items: center;
  }
    @media (max-width: ${size.tablet}) {
        flex-direction: column;
        width: 100%;
        padding: 10px;
        justify-content: center;
        align-items: center;
  }
`

const InputTextStyle = styled.input `
   cursor: pointer;
   background: #8fbaa3;
   color: #f5f0e5;
   border: none;
   font-size: 16px;
   height: 40px;
   width: 160px;
`

const Row = styled.div `
    display: flex;
    flex-direction: row;
    padding: 10px;
    
`

const Label = styled.label `
  padding: 10px;
  @media (max-width: ${size.tablet}) {
      padding: 20px;
      font-size: 14px;
  }
`
const Form = () => {
  const rotation = useStore((state) => state.rotation)
  const updateQuestionMode = useStore((state) => state.updateQuestionMode)
  const [values, setValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
});
  const [message, setMessage] = useState('')
  const [checked, setChecked] = useState(false)

  const handleFirstName = (e) => {
    e.persist();
    setValues((values) => ({
        ...values,
        firstName: e.target.value
    }))
}
const handleLastName = (e) => {
    e.persist();
    setValues((values) => ({
        ...values,
        lastName: e.target.value
    }))
}
const handleEmail = (e) => {
    e.persist();
    setValues((values) => ({
        ...values,
        email: e.target.value
    }))
}

function toggle(value) {
  return !value
}

  const onSubmit = async (e) => {
    console.log(checked)
    e.preventDefault();
    const data = {
      rotation: rotation,
      fName: values.firstName,
      lName: values.lastName,
      email: values.email,
    }
    if (checked === true) {
      await axios.post('/api/create', {
        data
      })
      .then(async function () {
        const response = await axios.get('/api/create')
        updateQuestionMode({ questionMode: false })
        setMessage("success!");
        e.target.reset();
  
      })
        .catch(function (response) {
          console.log(response);
          setMessage("error");
          e.target.reset();
      }); 
    } else {
      setMessage("Please tick the box to confirm")
    }
  } 
    
    return (
      <div>
        <p>{message}</p>
       <FormStyle >
        <FormWrapper onSubmit={onSubmit}>
          <Row>
            <Label htmlFor="fName">What is your first name?</Label>
            <InputTextStyle type="text" label="firstName" placeholder="first name"  onChange={handleFirstName}/>
          </Row>
          <Row>
            <Label htmlFor="lName">What is your last name?</Label>
            <InputTextStyle type="text" label="lastName" placeholder="last name"  onChange={handleLastName}/>
          </Row>
          <Row>
            <Label htmlFor="email">Enter your email</Label>
            <InputTextStyle type="email" label="email" placeholder="email"  onChange={handleEmail}/>
          </Row>
          <Label>Tick this box to agree to recieve our newsletter</Label>
            <input checked={checked} type="checkbox" onChange= {() => setChecked(toggle)}/>
          <SubmitBtn />
          <p>Entering your email will sign you up for exclusive East Devonly news!</p>
        </FormWrapper>
       </FormStyle>
      </div>
    );
  }
  
  export default Form;




